module.exports = __webpack_public_path__ + "static/media/prize-icon.926a67cc.png";